import { render } from "./CertificateCO2.vue?vue&type=template&id=77b2348b"
import script from "./CertificateCO2.vue?vue&type=script&lang=js"
export * from "./CertificateCO2.vue?vue&type=script&lang=js"

import "./CertificateCO2.vue?vue&type=style&index=0&id=77b2348b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__